import styled, { css } from 'styled-components';

export const Container = styled.div`
  z-index: 6;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;

  .flags-wrapper {
    height: 25px;
    display: flex;
    position: absolute;
    align-items: center;
  }

  .top_left {
    top: 6px;
    left: 6px;
  }

  .top_right {
    top: 6px;
    right: 6px;
    justify-content: flex-end;
  }

  .bottom_left {
    left: 6px;
    bottom: 6px;
  }

  .bottom_right {
    right: 6px;
    bottom: 6px;
    justify-content: flex-end;
  }
`;

export const Flag = styled.div`
  user-select: none;
  -webkit-user-drag: none;

  &:not(:first-child) {
    margin-left: 6px;
  }

  ${props => props.image && css`
    width: 25px;
    height: 25px;
    background: url("${props.image}");
    background-size: cover;
  `}

  span {
    font-size: 13px;
    padding: 5px 7px;
    font-weight: 400;
    border-radius: 6px;
    color: ${props => `${props.textColor} !important`};
    background: ${props => props.backgroundColor};
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.08);
  }
`;
